/** Tekst ispod scene za korak "Vozač"; isprave nose svoj naslov i opis iz DRIVER_DOCUMENT_STEPS. */
export const DRIVER_PERSON_INTRO_TEXT = {
  title: "Tko vozi ovo vozilo?",
  description: "Vozač je korisnik aplikacije ili osoba iz imenika. Uz njega se čuvaju isprave i njihovi rokovi.",
};

/** Opis ispod scene isprave: rok je ono što se prati. */
export const DRIVER_DOCUMENT_INTRO_DESCRIPTION =
  "Upišite broj i rok važenja te priložite presliku. Sustav upozorava prije nego isprava istekne.";

/** Primjeri dok korisnik ništa nije upisao. */
export const DRIVER_INTRO_SAMPLE = {
  name: "Marko Horvat",
  initials: "MH",
  documentNumber: "12345678",
  /** Rok primjera: godinu i pol od danas, da primjer ne istekne. */
  expiryInDays: 540,
};

/** Isprava ističe uskoro ako vrijedi još manje od ovoliko dana. */
export const DRIVER_DOCUMENT_WARNING_DAYS = 30;
